export default "__VITE_ASSET__e80d7144__"